module.exports = {"360483100":"南康镇","360483101":"白鹿镇","360483102":"温泉镇","360483103":"星子镇","360483104":"华林镇","360483105":"蛟塘镇","360483106":"横塘镇","360483107":"牯岭镇","360483108":"海会镇","360483200":"蓼南乡","360483401":"东牯山林场","360483500":"沙湖山管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360483.json
// module id = 1180
// module chunks = 0